import React, { createContext, useContext, ReactNode } from 'react';
import ApiClient from '../../lib/api-client';
import { IContractFileDTO } from '@common-frontend-submodule/interfaces/contract-file/icontract-file.interface';
import { IContractFileCreationDTO } from '@common-frontend-submodule/interfaces/contract-file/icontract-file-creation.interface';
import { IApiResponseGenericDTO } from '@common-frontend-submodule/interfaces/common/iapi-response.interface';
import { ContractFileRoutes } from '@common-frontend-submodule/enums/routes/contract-file-routes.enum';

const apiClient = ApiClient.getInstance()

interface ContractFileContextProps {
  getById: (contractFileId: string) => Promise<IApiResponseGenericDTO<IContractFileDTO>>;
  getAll: (contractId: string) => Promise<IApiResponseGenericDTO<IContractFileDTO[]>>;
  delete: (contractId: string) => Promise<IApiResponseGenericDTO<boolean>>;
  create: (file: File, model: IContractFileCreationDTO) => Promise<IApiResponseGenericDTO<IContractFileDTO>>;
}

const ContractFileContext = createContext<ContractFileContextProps | undefined>(undefined);

export const ContractFileProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const getById = async (contractFileId: string): Promise<IApiResponseGenericDTO<IContractFileDTO>> => {
    return await apiClient.getRequest<IContractFileDTO>(`${ContractFileRoutes.BasePrefix}/${contractFileId}`);
  };

  const getAll = async (contractId: string): Promise<IApiResponseGenericDTO<IContractFileDTO[]>> => {
    return await apiClient.getRequest<IContractFileDTO[]>(`${ContractFileRoutes.BasePrefix}/all/${contractId}`);
  };

  const create = async (file: File, model: IContractFileCreationDTO): Promise<IApiResponseGenericDTO<IContractFileDTO>> => {
    const formData = new FormData();

    formData.append('file', file);

    Object.entries(model).forEach(([key, value]) => {
      formData.append(key, value as string); // Преобразуем значение в строку
    });
  
    return await apiClient.postFormDataRequest<FormData, IContractFileDTO>(
      ContractFileRoutes.BasePrefix,
      formData,
    );
  };

  const deleteContractFile = async (contractFileId: string): Promise<IApiResponseGenericDTO<boolean>> => {
    return await apiClient.deleteRequest<null, boolean>(`${ContractFileRoutes.BasePrefix}/${contractFileId}`);
  };

  return (
    <ContractFileContext.Provider value={{ getById, getAll, create, delete: deleteContractFile }}>
      {children}
    </ContractFileContext.Provider>
  );
};

export const useContractFileStore = () => {
  const context = useContext(ContractFileContext);
  if (!context) {
    throw new Error('useContractFileStore must be used within a ContractFileProvider');
  }
  return context;
};
